
import { Component, Vue } from "vue-property-decorator";
import { GaodeService, OrganizationService, PackageService, OrderService, FamilyService } from "src/services";
import { Toast, Dialog } from "vant";
import dayjs from "dayjs";
import { CHECK_STATUS, ORDER_STATUS } from "src/enums";
import { Pay, tools } from "src/utils";

@Component
export default class GoodsDetail extends Vue
{
    /**
     * 商品数量
     * @private
     * @returns number
     */
     private goodsNum: number = 1;

}
